module.exports = __webpack_public_path__ + "img/loan_img_1.42db7673.png";